import { Link } from "react-router-dom";
import styled from "styled-components";

import ToolTip from "@/components/shared/ui/Tooltip";
import useIsMobile from "@/hooks/useIsMobile";

export const MenuTab = props => {
  const isMobile = useIsMobile();
  return (
    <TabWrapper $ismobile={isMobile}>
      {/* <Link
        to="/"
        className={props.tab === "" ? "selected" : ""}
        onClick={() => props.setTab("")}
      >
        OOSI
      </Link> */}
      <Tab
        to="/malligyong-tracker"
        className={props.tab === "malligyong-tracker" ? "selected" : ""}
        onClick={() => props.setTab("malligyong-tracker")}
      >
        Malligyong Tracker
      </Tab>
      <Tab
        to="/nurisat-tracker"
        className={props.tab === "nurisat-tracker" ? "selected" : ""}
        onClick={() => props.setTab("nurisat-tracker")}
      >
        NuriSat Tracker
      </Tab>
      <Tab
        to="/ntu-sat-tracker"
        className={props.tab === "NTU-Sat-tracker" ? "selected" : ""}
        onClick={() => props.setTab("NTU-Sat-tracker")}
      >
        NTU-Sat Tracker
      </Tab>
      <Tab
        to="/malay-sat-tracker"
        className={props.tab === "malay-sat-tracker" ? "selected" : ""}
        onClick={() => props.setTab("malay-sat-tracker")}
      >
        MALAY Sat Tracker
      </Tab>
      {/* 
      <ToolTip
        message={
          "MyOOSI will allow you create your own OOSI with a few clicks.\nThis service will be available very soon.\nIf you leave your contact information, we will invite you when it is ready."
        }
      >
        <Tab className={props.tab === "my-oosi" ? "selected" : ""}>
          MyOOSI
          <SubText>(under construction)</SubText>
        </Tab>
      </ToolTip> */}
    </TabWrapper>
  );
};

const TabWrapper = styled.ul`
  display: flex;
  flex-basis: ${props => (props.$ismobile ? "100%" : "none")};
  cursor: pointer;
  text-align: center;
  gap: 1rem;
  justify-content: space-evenly;
  margin-left: ${props => (props.$ismobile ? "0rem" : "3rem")};
  /* :nth-child(n) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 4rem;
    font-size: 1.4rem;
    font-weight: 500;
    padding: 0 1rem;
    text-decoration: none;
    color: inherit;
  }
  :nth-child(n):hover {
    background-color: #e7c11d;
    color: #001526;
  }
  .selected {
    background-color: #e7c11d;
    color: #001526;
  } */
`;

const Tab = styled(Link)`
  display: flex;
  flex-direction: column;
  width: auto;
  height: 3rem;

  padding: 1.4rem 0.9rem 0;

  justify-content: flex-start;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 700;

  text-decoration: none;
  color: inherit;

  &:hover {
    color: #e7c11d;
    /* color: #001526; */
  }
  &.selected {
    color: #e7c11d;
  }
`;

const SubText = styled.div`
  font-size: 1rem;
  font-weight: 300;
  margin-top: 0.5rem;
`;
